import DOMPurify from "dompurify";


const sanitizeRichHtml = (html) => {

  if (
    typeof html !== "string" ||
    !html
  ) {
    return "";
  }


  return DOMPurify.sanitize(
    html,
    {
      /*
       * Rich text is ordinary HTML.
       * SVG/MathML are not needed here.
       */
      USE_PROFILES: {
        html: true
      },

      /*
       * Chatra Sangbad's TipTap extensions
       * use data-* attributes for features
       * such as drop caps / rich-text shapes.
       */
      ALLOW_DATA_ATTR: true,

      /*
       * Preserve legitimate accessibility
       * attributes generated by content.
       */
      ALLOW_ARIA_ATTR: true,

      /*
       * None of these active/interactive
       * elements belong inside published
       * editorial rich text.
       */
      FORBID_TAGS: [
        "script",
        "style",
        "iframe",
        "object",
        "embed",
        "form",
        "input",
        "button",
        "textarea",
        "select",
        "option",
        "meta",
        "link",
        "base"
      ]
    }
  );

};


export default sanitizeRichHtml;